import React, { useEffect } from 'react';
import { ArrowRight, ArrowLeft } from '../icons';
import { IMG } from '../data/constants';

const SLIDE_COUNT = 3;
const go = (current, delta) => ((current + delta) % SLIDE_COUNT + SLIDE_COUNT) % SLIDE_COUNT;

const Hero = ({ t, slideIdx, setSlide }) => {
  const current = t.slides[slideIdx];

  useEffect(() => {
    const timer = setInterval(() => {
      setSlide(go(slideIdx, 1));
    }, 5000);
    return () => clearInterval(timer);
  }, [slideIdx, setSlide]);

  return (
    /* full-width hero — image fills entire viewport width */
    <div
      className="relative h-[720px] shrink-0 overflow-hidden"
      style={{ background: 'radial-gradient(120% 100% at 72% 28%, #5b8ab8 0%, #2f5f92 52%, #16324f 100%)' }}
    >
      {/* Background image — full width */}
      <img src={IMG.hero[slideIdx]} alt="" className="absolute inset-0 w-full h-full object-cover block" />

      {/* Full-width elegant dark overlay (darker on left for text readability) */}
      <div
        className="absolute inset-0"
        style={{ background: 'linear-gradient(to right, rgba(14,36,62,0.85) 0%, rgba(14,36,62,0.4) 50%, rgba(14,36,62,0.1) 100%)' }}
      />
      
      {/* Bottom gradient overlay — full width */}
      <div
        className="absolute left-0 right-0 bottom-0 h-[220px]"
        style={{ background: 'linear-gradient(to top, rgba(14,36,62,0.6), rgba(14,36,62,0))' }}
      />

      {/* Content constraint layer — centred at 1440px, pointer-events forwarded */}
      <div className="absolute inset-0 max-w-[1440px] mx-auto pointer-events-none">

        {/* Slide panel — left-anchored */}
        <div
          className="absolute left-[120px] bottom-12 w-[620px] box-border text-white flex flex-col gap-5 pointer-events-auto drop-shadow-md"
        >
          {/* Eyebrow */}
          <div className="flex items-center gap-[14px] text-[12px] font-bold tracking-[0.18em] uppercase text-gold">
            {current.eyebrow}
          </div>

          {/* Title */}
          <h1 className="m-0 min-h-[112px] font-heading font-medium text-[52px] leading-[1.08] tracking-[-0.01em]">
            {current.title}
          </h1>

          {/* Body */}
          <p className="m-0 min-h-[84px] text-[17px] leading-[1.65] text-white/90">
            {current.body}
          </p>

          {/* Buttons */}
          <div className="flex gap-3 pt-1">
            <a
              className="btn flex items-center h-[50px] px-[26px] rounded-[3px] bg-gold text-navy-deep text-[12.5px] font-bold tracking-widest uppercase"
              href="#"
            >
              {t.visit}
            </a>
            <a
              className="flex items-center h-[50px] px-[26px] rounded-[3px] border-[1.5px] border-white/60 text-white text-[12.5px] font-bold tracking-widest uppercase"
              href="#"
            >
              {t.explore}
            </a>
          </div>
        </div>

        {/* Carousel controls — right-anchored */}
        <div className="absolute right-[120px] bottom-10 flex items-center gap-6 text-white pointer-events-auto">

          {/* Counter */}
          <span className="text-[13px] font-semibold tracking-[0.12em]">
            {'0' + (slideIdx + 1) + ' / 0' + SLIDE_COUNT}
          </span>

          {/* Dot indicators */}
          <div className="flex items-center">
            {[0, 1, 2].map((i) => (
              <button
                key={i}
                aria-label={`${t.slideLabel} ${i + 1}`}
                onClick={() => setSlide(i)}
                className="h-11 w-16 px-1 border-0 bg-transparent flex items-center cursor-pointer"
              >
                <span
                  className="block w-full h-[3px]"
                  style={{ background: i === slideIdx ? 'var(--gold)' : 'rgba(255,255,255,0.4)' }}
                />
              </button>
            ))}
          </div>

          {/* Prev / Next */}
          <div className="flex gap-2">
            <button
              aria-label="Previous slide"
              onClick={() => setSlide(go(slideIdx, -1))}
              className="w-12 h-12 rounded-[3px] border-[1.5px] border-white/70 bg-transparent text-white flex items-center justify-center p-0 cursor-pointer"
            >
              <ArrowLeft />
            </button>
            <button
              aria-label="Next slide"
              onClick={() => setSlide(go(slideIdx, 1))}
              className="w-12 h-12 rounded-[3px] border-[1.5px] border-white/70 bg-transparent text-white flex items-center justify-center p-0 cursor-pointer"
            >
              <ArrowRight />
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Hero;
